import { useUpdatePiecesMutation } from '@api/piece';
import { PieceAction } from '@apiContract';

import { DialogConfirmation } from '@uiKit/DialogConfirmation';

import { showApiErrorToast } from '@utils/apiErrorToast';

import { ActionComponentProps } from '../../index';
import { buildUpdatePiecesRequest } from './helper';

export const Delete = ({ mailpieces, actionStarted, onActionFinish, onClose }: ActionComponentProps) => {
  const [updatePieces, { isLoading }] = useUpdatePiecesMutation();

  const runDeleteAction = async () => {
    try {
      const requestData = buildUpdatePiecesRequest({
        mailpieces,
        action: PieceAction.Delete,
      });
      await updatePieces(requestData).unwrap();
      onActionFinish();
    } catch (error) {
      showApiErrorToast(error);
    }
  };

  const close = onClose ? onClose : onActionFinish;

  return (
    <DialogConfirmation
      maxWidth="xs"
      open={actionStarted}
      handleClose={close}
      title="Delete item"
      content="Are you sure you would like to permanently delete this item?"
      type="error"
      acceptButtonHandleClick={runDeleteAction}
      cancelButtonHandleClick={close}
      acceptButtonTitle="Delete"
      cancelButtonTitle="Cancel"
      loading={isLoading}
    />
  );
};
